import { useDispatchTool, useStateTool } from 'app/store/withDevTools';
import React from 'react';
import { fornecedorReducer, initState } from './fornecedorReducer';

const FornecedorContext = React.createContext();
const FornecedorDispatchContext = React.createContext();

const FornecedorProvider = (props) => {
  const [state, dispatch] = React.useReducer(fornecedorReducer, initState);

  return (
    <FornecedorContext.Provider value={state}>
      <FornecedorDispatchContext.Provider value={dispatch}>{props.children}</FornecedorDispatchContext.Provider>
    </FornecedorContext.Provider>
  );
};

function FornecedorConsumer({ children }) {
  return (
    <FornecedorContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('FornecedorConsumer must be used within a FornecedorProvider');
        }

        return children(context);
      }}
    </FornecedorContext.Consumer>
  );
}

function useFornecedor() {
  return [
    useStateTool(FornecedorContext, 'FornecedorContext'),
    useDispatchTool(FornecedorDispatchContext, 'FornecedorDispatchContext'),
  ];
}

export { FornecedorProvider, FornecedorConsumer, useFornecedor };
